import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { initAnalytics, pageview } from "@/lib/analytics";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Vision from "@/pages/Vision";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudy from "@/pages/CaseStudy";
import Insights from "@/pages/Insights";
import Article from "@/pages/Article";
import Tools from "@/pages/Tools";
import Calculator from "@/pages/Calculator";
import Downloads from "@/pages/Downloads";
import Sourcing from "@/pages/Sourcing";
import Country from "@/pages/Country";
import FAQ from "@/pages/FAQ";
import Book from "@/pages/Book";
import ThankYou from "@/pages/ThankYou";
import Guide from "@/pages/Guide";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Sitemap from "@/pages/Sitemap";
import Contact from "@/pages/Contact";
import PaymentResult from "@/pages/PaymentResult";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";
import NewsletterPopup from "@/components/NewsletterPopup";

function ScrollAndTrack() {
  const loc = useLocation();
  // eslint-disable-next-line -- pageview is a stable module import
  useEffect(() => {
    if (loc.hash) {
      const el = document.querySelector(loc.hash);
      if (el) { el.scrollIntoView(); pageview(loc.pathname + loc.hash); return; }
    }
    window.scrollTo(0, 0);
    pageview(loc.pathname);
  }, [loc.pathname, loc.hash]);
  return null;
}

function App() {
  // eslint-disable-next-line -- initAnalytics runs once on mount
  useEffect(() => { initAnalytics(); }, []);
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <ScrollAndTrack />
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/vision" element={<Vision />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/case-studies/:slug" element={<CaseStudy />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<Article />} />
              <Route path="/tools" element={<Tools />} />
              <Route path="/tools/landed-cost-and-margin-calculator" element={<Calculator />} />
              <Route path="/tools/downloads" element={<Downloads />} />
              <Route path="/sourcing" element={<Sourcing />} />
              <Route path="/sourcing/:slug" element={<Country />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/book" element={<Book />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/guides/first-production-run-australia" element={<Guide />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/sitemap" element={<Sitemap />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <NewsletterPopup />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}

export default App;
